import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const trackLectureApiService = createApi({
  reducerPath: "trackLecture",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createTrackLecture: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `tracklecture/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    createAIMessage: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `tracklecture/message${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getAIUserHistory: builder.query({
      query: (params) => {
        const query = queryParams(params);
        return {
          url: `tracklecture/ai/history${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateTrackLectureMutation,
  useCreateAIMessageMutation,
  useGetAIUserHistoryQuery,
} = trackLectureApiService;
